import informationService from '../services/system';
import { format, addDays, addWeeks, addMonths, addYears, addHours, addMinutes, addSeconds } from "date-fns";

const entityTinPin = (idFieldTable, data, itemDoc, field, setField, changeValue) => {

    if (idFieldTable === 'argTin' || idFieldTable === 'argPin') {

        data.forEach((itemData) => {
            if (Number(itemData.id) === Number(itemDoc.idDoc)) {
                itemData.boxes.forEach((itemBoxes) => {
                    itemBoxes.fields.forEach((itemFields) => {
                        if (idFieldTable === 'argTin') {
                            if (itemFields.idFieldTable === 'tin') {

                                let idfield = itemFields.id;
                                if (itemFields.id.split('_').length === 1)
                                    idfield = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`

                                if (!field[idfield]) {
                                    setField(prevState => ({
                                        ...prevState,
                                        [idfield]: changeValue
                                    }));
                                }
                            }
                        } else {
                            if (itemFields.idFieldTable === 'pin') {

                                let idfield = itemFields.id;
                                if (itemFields.id.split('_').length === 1)
                                    idfield = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`

                                if (!field[idfield]) {
                                    setField(prevState => ({
                                        ...prevState,
                                        [idfield]: changeValue
                                    }));
                                }
                            }
                        }
                    })
                })
            }
        })
    }

}

const entityArgRpcRegNumber = (idFieldTable, data, itemDoc, field, setField, changeValue, id) => {

    let idArgRpcRegNumber;
    let argRpcRegNumber;
    let argRpcRegBook;
    let argRpcRegFolio;
    let argRpcRegVolume;
    let argRegNumber;

    data.forEach((itemData) => {
        if (Number(itemData.id) === Number(itemDoc.id)) {
            itemData.boxes.forEach((itemBoxes) => {
                itemBoxes.fields.forEach((itemFields) => {
                    if (itemFields.idFieldTable === 'argCvRegTypeId') {
                        /*let entityDocFlag = itemData.entityDocId;
                        if (itemData.entityDocId.length > 1) {
                            entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                        }

                        idArgRpcRegNumber = entityDocFlag + itemFields.id;*/
                        idArgRpcRegNumber = itemFields.id;
                        if (itemFields.id.split('_').length === 1)
                            idArgRpcRegNumber = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                    }
                    if (itemFields.idFieldTable === 'argRpcRegNumber') {
                        /*let entityDocFlag = itemData.entityDocId;
                        if (itemData.entityDocId.length > 1) {
                            entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                        }

                        argRpcRegNumber = entityDocFlag + itemFields.id;*/
                        argRpcRegNumber = itemFields.id;
                        if (itemFields.id.split('_').length === 1)
                            argRpcRegNumber = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                    }
                    if (itemFields.idFieldTable === 'argRpcRegBook') {
                        /*let entityDocFlag = itemData.entityDocId;
                        if (itemData.entityDocId.length > 1) {
                            entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                        }

                        argRpcRegBook = entityDocFlag + itemFields.id;*/
                        argRpcRegBook = itemFields.id;
                        if (itemFields.id.split('_').length === 1)
                            argRpcRegBook = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                    }
                    if (itemFields.idFieldTable === 'argRpcRegFolio') {
                        /*let entityDocFlag = itemData.entityDocId;
                        if (itemData.entityDocId.length > 1) {
                            entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                        }

                        argRpcRegFolio = entityDocFlag + itemFields.id;*/
                        argRpcRegFolio = itemFields.id;
                        if (itemFields.id.split('_').length === 1)
                            argRpcRegFolio = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                    }
                    if (itemFields.idFieldTable === 'argRpcRegVolume') {
                        /*let entityDocFlag = itemData.entityDocId;
                        if (itemData.entityDocId.length > 1) {
                            entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                        }

                        argRpcRegVolume = entityDocFlag + itemFields.id;*/
                        argRpcRegVolume = itemFields.id;
                        if (itemFields.id.split('_').length === 1)
                            argRpcRegVolume = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                    }
                    if (itemFields.idFieldTable === 'argRegNumber') {
                        /*let entityDocFlag = itemData.entityDocId;
                        if (itemData.entityDocId.length > 1) {
                            entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                        }

                        argRegNumber = entityDocFlag + itemFields.id;*/
                        argRegNumber = itemFields.id;
                        if (itemFields.id.split('_').length === 1)
                            argRegNumber = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                    }
                })
            })
        }
    })


    if (id === argRpcRegNumber || id === argRpcRegBook || id === argRpcRegFolio || id === argRpcRegVolume) {
        if (Number(field[idArgRpcRegNumber].id) === 1) {
            if (idFieldTable === 'argRpcRegNumber')
                argRpcRegNumber = changeValue;
            else
                argRpcRegNumber = field[argRpcRegNumber];
            if (idFieldTable === 'argRpcRegBook')
                argRpcRegBook = changeValue;
            else
                argRpcRegBook = field[argRpcRegBook];
            if (idFieldTable === 'argRpcRegFolio')
                argRpcRegFolio = changeValue;
            else
                argRpcRegFolio = field[argRpcRegFolio];
            if (idFieldTable === 'argRpcRegVolume')
                argRpcRegVolume = changeValue;
            else
                argRpcRegVolume = field[argRpcRegVolume];

            let valueArgRegNumber = `${argRpcRegNumber}${argRpcRegBook}${argRpcRegFolio}${argRpcRegVolume}`;


            setField(prevState => ({
                ...prevState,
                [argRegNumber]: valueArgRegNumber
            }));
        }
    }
}

const addressBook = (idFieldTable, field, setField, changeValue, id, group, nameGroup, indexGroup, info, nameSubGroup, indexSubGroup) => {

    try {
        if (idFieldTable === 'addressTypeId' && nameGroup.includes('Teléfono')) {
            let existe = false;
            let idSwitch;
            for (let y = 0; y < group[nameGroup].length; y++) {
                if (y === indexGroup) {

                    if (nameSubGroup) {
                        for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                            for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'isDefault') {
                                    idSwitch = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        idSwitch = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`
                                }
                            }

                        }
                    } else {
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {

                            if (group[nameGroup][y].fields[i].idFieldTable === 'isDefault') {
                                idSwitch = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    idSwitch = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`
                            }
                        }
                    }
                }
            }

            for (let y = 0; y < group[nameGroup].length; y++) {
                if (y !== indexGroup) {
                    if (nameSubGroup) {
                        for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                            for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'addressTypeId') {
                                    let idFied = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                    if (field[idFied]) {
                                        if (Number(changeValue.id) === Number(field[idFied].id)) {
                                            existe = true;
                                        }
                                    }
                                }
                            }

                        }
                    } else {
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {


                                let idFied = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                                if (field[idFied]) {
                                    if (Number(changeValue.id) === Number(field[idFied].id)) {
                                        existe = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (existe === false) {
                setField(prevState => ({
                    ...prevState,
                    [idSwitch]: true
                }), []);
            } else {
                setField(prevState => ({
                    ...prevState,
                    [idSwitch]: false
                }), []);
            }
        }
        if (idFieldTable === 'isDefault') {
            if (changeValue === true) {
                let idAddressType;
                let existe = false;
                let indexUpdate;
                for (let y = 0; y < group[nameGroup].length; y++) {
                    if (y === indexGroup) {
                        if (nameSubGroup) {
                            for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {

                                if (i === indexSubGroup) {
                                    for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                        if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'addressTypeId') {
                                            let idAddressTypeId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                            if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                                idAddressTypeId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                            if (field[idAddressTypeId])
                                                idAddressType = Number(field[idAddressTypeId].id)
                                        }
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {

                                if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {

                                    //let idAddressTypeId = group[nameGroup][y].fields[i].id;
                                    let idAddressTypeId = group[nameGroup][y].fields[i].id;
                                    if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                        idAddressTypeId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`


                                    if (field[idAddressTypeId])
                                        idAddressType = Number(field[idAddressTypeId].id)
                                }
                            }
                        }
                    }
                }
                for (let y = 0; y < group[nameGroup].length; y++) {
                    if (y !== indexGroup) {
                        if (nameSubGroup) {
                            for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                                if (i !== indexSubGroup) {
                                    for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                        if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'addressTypeId') {
                                            let idFied = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                            if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                                idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                            if (field[idFied]) {
                                                if (idAddressType === Number(field[idFied].id)) {
                                                    existe = true;
                                                    indexUpdate = i;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {


                                    let idFied = group[nameGroup][y].fields[i].id;
                                    if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                        idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`


                                    if (field[idFied]) {
                                        if (idAddressType === Number(field[idFied].id)) {
                                            existe = true;
                                            indexUpdate = y;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (existe === true) {
                    for (let y = 0; y < group[nameGroup].length; y++) {


                        if (nameSubGroup) {
                            for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                                if (i === indexUpdate) {
                                    for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                        if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'isDefault') {
                                            let idSwitch = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                            if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                                idSwitch = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                            setField(prevState => ({
                                                ...prevState,
                                                [idSwitch]: false
                                            }), [])
                                        }
                                    }
                                }
                            }
                        } else {
                            if (y === indexUpdate) {
                                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                    if (group[nameGroup][y].fields[i].idFieldTable === 'isDefault') {

                                        //let idSwitch = group[nameGroup][y].fields[i].id;
                                        let idSwitch = group[nameGroup][y].fields[i].id;
                                        if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                            idSwitch = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                                        setField(prevState => ({
                                            ...prevState,
                                            [idSwitch]: false
                                        }), []);
                                    }
                                }
                            }
                        }
                    }
                }

            } else {
                if (group[nameGroup].length === 1) {
                    setField(prevState => ({
                        ...prevState,
                        [id]: true
                    }), []);
                } else {
                    let idEntityType = null;
                    let existe = false;
                    let indexUpdate;
                    for (let y = 0; y < group[nameGroup].length; y++) {
                        if (y === indexGroup) {

                            if (nameSubGroup) {
                                for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {

                                    if (i === indexSubGroup) {
                                        for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                            if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'addressTypeId') {
                                                let idFied = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                                    idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                                if (field[idFied])
                                                    idEntityType = Number(field[idFied].id);
                                            }
                                        }
                                    }
                                }
                            } else {
                                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                    if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {


                                        let idFied = group[nameGroup][y].fields[i].id;
                                        if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                            idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`


                                        if (field[idFied])
                                            idEntityType = Number(field[idFied].id);
                                    }
                                }
                            }
                        }
                    }

                    for (let y = 0; y < group[nameGroup].length; y++) {
                        if (y !== indexGroup) {
                            if (nameSubGroup) {
                                for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                                    if (i !== indexSubGroup) {
                                        for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                            if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'addressTypeId') {
                                                let idFied = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                                    idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                                if (field[idFied]) {
                                                    if (idEntityType === Number(field[idFied].id)) {
                                                        existe = true;
                                                        indexUpdate = y;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                    if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {


                                        let idFied = group[nameGroup][y].fields[i].id;
                                        if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                            idFied = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`


                                        if (field[idFied]) {
                                            if (idEntityType === Number(field[idFied].id)) {
                                                existe = true;
                                                indexUpdate = y;
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }

                    if (existe === false) {
                        setField(prevState => ({
                            ...prevState,
                            [id]: true
                        }), []);
                    } else {
                        for (let y = 0; y < group[nameGroup].length; y++) {

                            if (nameSubGroup) {
                                for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                                    if (i === indexUpdate) {
                                        for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                            if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'isDefault') {
                                                let idSwitch = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                                    idSwitch = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idSwitch]: true
                                                }), []);
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (y === indexUpdate) {
                                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                        if (group[nameGroup][y].fields[i].idFieldTable === 'isDefault') {

                                            //let idSwitch = group[nameGroup][y].fields[i].id;
                                            let idSwitch = group[nameGroup][y].fields[i].id;
                                            if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                                idSwitch = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                                            setField(prevState => ({
                                                ...prevState,
                                                [idSwitch]: true
                                            }), []);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        }
        //addressBook name
        if (idFieldTable === 'street' || idFieldTable === 'number' || idFieldTable === 'floor' || idFieldTable === 'department') {
            let nameId;
            let nameAltId;
            let street;
            let streetId;
            let number;
            let numberId;
            let floor;
            let floorId;
            let department;
            let departmentId;
            for (let y = 0; y < group[nameGroup].length; y++) {
                if (y === indexGroup) {

                    if (nameSubGroup) {
                        for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                            for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'name') {
                                    nameId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        nameId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'nameAlt') {
                                    nameAltId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        nameAltId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'street') {
                                    streetId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        streetId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'number') {
                                    numberId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        numberId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'floor') {
                                    floorId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        floorId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`
                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'department') {
                                    departmentId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        departmentId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`
                                }
                            }

                        }
                    } else {
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {

                            if (group[nameGroup][y].fields[i].idFieldTable === 'name') {
                                nameId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    nameId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'nameAlt') {
                                //nameAltId = group[nameGroup][y].fields[i].id;
                                nameAltId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    nameAltId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'street') {
                                //streetId = group[nameGroup][y].fields[i].id;
                                streetId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    streetId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'number') {
                                //numberId = group[nameGroup][y].fields[i].id;
                                numberId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    numberId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'floor') {
                                //floorId = group[nameGroup][y].fields[i].id;
                                floorId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    floorId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'department') {
                                //departmentId = group[nameGroup][y].fields[i].id;
                                departmentId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    departmentId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                        }
                    }
                }
            }

            if (idFieldTable === 'street')
                street = changeValue;
            else
                street = field[streetId];

            if (idFieldTable === 'number')
                number = changeValue;
            else
                number = field[numberId];

            if (idFieldTable === 'floor')
                floor = changeValue;
            else
                floor = field[floorId];

            if (idFieldTable === 'department')
                department = changeValue;
            else
                department = field[departmentId];

            setField(prevState => ({
                ...prevState,
                [nameId]: `${street} ${number}`,
                [nameAltId]: `Piso: ${floor} Dpto.: ${department}`
            }), []);

        }

        //addressBook zip
        if (idFieldTable === 'zipId') {
            let countryId;
            let zipTxtId;
            let cityId;
            let stateId;
            let stateTxtId;
            for (let y = 0; y < group[nameGroup].length; y++) {
                if (y === indexGroup) {
                    if (nameSubGroup) {
                        for (let i = 0; i < group[nameGroup][y].subGroup[0][nameSubGroup].length; i++) {
                            for (let e = 0; e < group[nameGroup][y].subGroup[0][nameSubGroup][i].fields.length; e++) {

                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'countryId') {
                                    countryId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        countryId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'zipTxt') {
                                    zipTxtId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        zipTxtId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'city') {
                                    cityId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        cityId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'stateTxt') {
                                    stateTxtId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        stateTxtId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`

                                }
                                if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].idFieldTable === 'stateId') {
                                    stateId = group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id;
                                    if (group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id.split('_').length === 1)
                                        stateId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].subGroup[0][nameSubGroup][i].fields[e].id}`
                                }

                            }

                        }
                    } else {

                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {

                            if (group[nameGroup][y].fields[i].idFieldTable === 'countryId') {
                                countryId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    countryId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'zipTxt') {
                                zipTxtId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    zipTxtId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'city') {
                                cityId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    cityId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'stateTxt') {
                                stateTxtId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    stateTxtId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`

                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'stateId') {
                                stateId = group[nameGroup][y].fields[i].id;
                                if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                                    stateId = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${group[nameGroup][y].fields[i].id}`
                            }

                        }
                    }
                }
            }
            if (field[countryId]) {
                if (Number(field[countryId].id) === 10) {
                    info.forEach(item => {
                        if (Number(item.id) === Number(changeValue.id) && item.source === 'zip') {
                            let stateTxt;
                            let stateObj = {};
                            info.forEach(item1 => {

                                if (Number(item.stateId) === Number(item1.id) && item1.source === 'state') {
                                    stateTxt = item1.name;
                                    stateObj = {
                                        id: item1.id,
                                        label: item1.nameAlt !== undefined ? `${item1.name} ${item1.nameAlt}` : `${item1.name}`,
                                    }
                                }
                            })

                            setField(prevState => ({
                                ...prevState,
                                [zipTxtId]: item.name,
                                [cityId]: item.nameAlt,
                                [stateId]: stateObj,
                                [stateTxtId]: stateTxt,
                            }), []);
                        }
                    })
                }
            }
        }

    } catch (error) {
        console.log(error)
    }
}

const entityTinPinGroup = (idFieldTable, field, setField, changeValue, group, nameGroup) => {

    if (idFieldTable === 'argTin' || idFieldTable === 'argPin') {
        for (let y = 0; y < group[nameGroup].length; y++) {
            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                if (idFieldTable === 'argTin') {
                    if (group[nameGroup][y].fields[i].idFieldTable === 'tin') {
                        let idg = group[nameGroup][y].fields[i].id;
                        if (!field[idg]) {
                            setField(prevState => ({
                                ...prevState,
                                [idg]: changeValue
                            }), []);
                        }
                    }
                }
                if (idFieldTable === 'argPin') {
                    if (group[nameGroup][y].fields[i].idFieldTable === 'pin') {
                        let idg = group[nameGroup][y].fields[i].id;
                        if (!field[idg]) {
                            setField(prevState => ({
                                ...prevState,
                                [idg]: changeValue
                            }), []);
                        }
                    }
                }
            }
        }
    }

}

const calcularPerfilInversor = (id, changeValue, data, field, investorProfile, setField) => {
    let calcula = true;
    let puntaje = 0;
    let idPuntos;
    let idPerfil;

    data.forEach((itemData) => {
        if (itemData.entityDocId === '7') {
            itemData.boxes.forEach((itemBoxes) => {
                itemBoxes.fields.forEach((itemFields) => {

                    let idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                    if (itemFields.type === 'Radio' && idField !== id) {
                        if (!field[idField])
                            calcula = false;
                        else
                            puntaje = puntaje + Number(field[idField])
                    }
                    if (itemFields.name === 'Puntos')
                        idPuntos = idField;
                    if (itemFields.idFieldTable === 'investorProfileId')
                        idPerfil = idField;
                })
            })
        }
    })

    puntaje = puntaje + Number(changeValue);

    let perfil;
    for (let r = 0; r < investorProfile.length; r++) {
        if (Number(puntaje) >= Number(investorProfile[r].min) && Number(puntaje) <= Number(investorProfile[r].max)) {
            perfil = { id: investorProfile[r].id, label: investorProfile[r].nameAlt !== null ? `${investorProfile[r].name} ${investorProfile[r].nameAlt}` : `${investorProfile[r].name}`, isInactive: '0' }
        }
    }

    if (calcula === true && puntaje && perfil) {

        setField(prevState => ({
            ...prevState,
            [idPuntos]: puntaje,
            [idPerfil]: perfil
        }), []);
    }
}

const requestCode = (idFieldTable, setRequestCode, data, changeValue, setField) => {

    if (idFieldTable === 'requestCode') {

        setRequestCode(changeValue);
        data.forEach((itemData) => {
            itemData.boxes.forEach((itemBoxes) => {
                itemBoxes.fields.forEach((itemFields) => {
                    if (itemFields.defaultValue === 'requestCode()') {

                        let idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`

                        setField(prevState => ({
                            ...prevState,
                            [idField]: changeValue
                        }), []);
                    }
                })
            })

        })
    }
}

const globalFunctionsDocs = (mode, load, loadGroup, item, nameGroup, user, changeValue, data, setField, instance, paymentTerm, orderBox, field, AuthService, group, id, index, info) => {

    if ((mode === 'u' || mode === 'c') && !load && !loadGroup) {
        //CURRENCY ID
        if (item.idFieldTable === 'currencyId') {
            console.log('changeValue.id-> ' + changeValue.id)
            console.log('user.data.currencyId-> ' + user.data.currencyId)

            if (changeValue.id === user.data.currencyId) {
                let idfield = null;
                let fxRate = null;
                if (!nameGroup) {
                    data.crud.boxes.forEach((itemBoxes) => {
                        if (itemBoxes.order === orderBox) {
                            itemBoxes.fields.forEach((itemFields) => {
                                if (itemFields.idFieldTable === 'fxRate') {
                                    idfield = itemFields.id;
                                    fxRate = "1";
                                    if (itemFields.type.includes('Number')) {
                                        let step = 0;
                                        let decimalValueFlag = itemFields.type.split('ber');
                                        if (decimalValueFlag.length > 1) {
                                            if (decimalValueFlag[1])
                                                step = (decimalValueFlag[1]);
                                            let valueSplit = fxRate.split(',');

                                            if (valueSplit.length > 1) {
                                                if (Number(valueSplit[1].length) < Number(step)) {
                                                    let ceros = '';
                                                    let dif = Number(step) - Number(valueSplit[1].length);
                                                    for (let o = 0; o < dif; o++) {
                                                        ceros = ceros + '0';
                                                    }
                                                    fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                } else {
                                                    fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                }
                                            } else {
                                                if (step > 0) {
                                                    let ceros = '';
                                                    for (let o = 0; o < step; o++) {
                                                        ceros = ceros + '0';
                                                    }
                                                    fxRate = `${valueSplit[0]},${ceros}`;
                                                }
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    })
                } else {
                    for (let y = 0; y < group[nameGroup].length; y++) {
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                            if (y === index) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'fxRate') {
                                    idfield = group[nameGroup][y].fields[i].id;
                                    fxRate = "1";
                                    if (group[nameGroup][y].fields[i].type.includes('Number')) {
                                        let step = 0;
                                        let decimalValueFlag = group[nameGroup][y].fields[i].type.split('ber');
                                        if (decimalValueFlag.length > 1) {
                                            if (decimalValueFlag[1])
                                                step = (decimalValueFlag[1]);
                                            let valueSplit = fxRate.split(',');

                                            if (valueSplit.length > 1) {
                                                if (Number(valueSplit[1].length) < Number(step)) {
                                                    let ceros = '';
                                                    let dif = Number(step) - Number(valueSplit[1].length);
                                                    for (let o = 0; o < dif; o++) {
                                                        ceros = ceros + '0';
                                                    }
                                                    fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                } else {
                                                    fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                }
                                            } else {
                                                if (step > 0) {
                                                    let ceros = '';
                                                    for (let o = 0; o < step; o++) {
                                                        ceros = ceros + '0';
                                                    }
                                                    fxRate = `${valueSplit[0]},${ceros}`;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                setField(prevState => ({
                    ...prevState,
                    [idfield]: fxRate,
                }), []);
            } else {
                let currencyId = changeValue.id;
                let date;
                data.crud.boxes.forEach((itemBoxes) => {
                    if (orderBox === itemBoxes.order) {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'date') {
                                let idfield = itemFields.id;
                                date = field[idfield];
                            }
                        })
                    }
                })
                if (!date) {
                    data.crud.boxes.forEach((itemBoxes) => {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'date') {
                                let idfield = itemFields.id;
                                date = field[idfield];
                            }
                        })
                    })
                }
                informationService.searchForeignCurrency(instance, date, currencyId).then((response) => {
                    const fxRate1 = response.data.toString().replace(/\./g, ',');;

                    if (!nameGroup) {
                        let fxRate = fxRate1;
                        let existe = false;
                        data.crud.boxes.forEach((itemBoxes) => {
                            if (orderBox === itemBoxes.order) {
                                itemBoxes.fields.forEach((itemFields) => {
                                    if (itemFields.idFieldTable === 'fxRate') {
                                        let idfield = itemFields.id;
                                        if (itemFields.type.includes('Number')) {
                                            let step = 0;
                                            let decimalValueFlag = itemFields.type.split('ber');
                                            if (decimalValueFlag.length > 1) {
                                                if (decimalValueFlag[1])
                                                    step = (decimalValueFlag[1]);
                                                let valueSplit = fxRate.split(',');

                                                if (valueSplit.length > 1) {
                                                    if (Number(valueSplit[1].length) < Number(step)) {
                                                        let ceros = '';
                                                        let dif = Number(step) - Number(valueSplit[1].length);
                                                        for (let o = 0; o < dif; o++) {
                                                            ceros = ceros + '0';
                                                        }
                                                        fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                    } else {
                                                        fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                    }
                                                } else {
                                                    if (step > 0) {
                                                        let ceros = '';
                                                        for (let o = 0; o < step; o++) {
                                                            ceros = ceros + '0';
                                                        }
                                                        fxRate = `${valueSplit[0]},${ceros}`;
                                                    }
                                                }
                                            }
                                        }
                                        setField(prevState => ({
                                            ...prevState,
                                            [idfield]: fxRate
                                        }), []);
                                        existe = true;
                                    }
                                })
                            }
                        })
                        if (!existe) {
                            data.crud.boxes.forEach((itemBoxes) => {
                                itemBoxes.fields.forEach((itemFields) => {
                                    if (itemFields.idFieldTable === 'fxRate') {
                                        let idfield = itemFields.id;
                                        setField(prevState => ({
                                            ...prevState,
                                            [idfield]: fxRate
                                        }), []);
                                    }
                                })
                            })
                        }
                    } else {
                        let fxRate = fxRate1;
                        for (let y = 0; y < group[nameGroup].length; y++) {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (y === index) {
                                    if (group[nameGroup][y].fields[i].idFieldTable === 'fxRate') {
                                        let idfield = group[nameGroup][y].fields[i].id;
                                        if (group[nameGroup][y].fields[i].type.includes('Number')) {
                                            let step = 0;
                                            let decimalValueFlag = group[nameGroup][y].fields[i].type.split('ber');
                                            if (decimalValueFlag.length > 1) {
                                                if (decimalValueFlag[1])
                                                    step = (decimalValueFlag[1]);
                                                let valueSplit = fxRate.split(',');

                                                if (valueSplit.length > 1) {
                                                    if (Number(valueSplit[1].length) < Number(step)) {
                                                        let ceros = '';
                                                        let dif = Number(step) - Number(valueSplit[1].length);
                                                        for (let o = 0; o < dif; o++) {
                                                            ceros = ceros + '0';
                                                        }
                                                        fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                    } else {
                                                        fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                    }
                                                } else {
                                                    if (step > 0) {
                                                        let ceros = '';
                                                        for (let o = 0; o < step; o++) {
                                                            ceros = ceros + '0';
                                                        }
                                                        fxRate = `${valueSplit[0]},${ceros}`;
                                                    }
                                                }
                                            }
                                        }
                                        let fxRateF=fxRate;
                                        setField(prevState => ({
                                            ...prevState,
                                            [idfield]: fxRateF
                                        }), []);
                                    }
                                }
                            }
                        }
                    }


                })
            }

        }
        //DATE
        if (item.idFieldTable === 'date' && !nameGroup) {
            let fecha = changeValue;
            //CURRENCY ID
            let currencyId;
            data.crud.boxes.forEach((itemBoxes) => {
                if (orderBox === itemBoxes.order) {
                    itemBoxes.fields.forEach((itemFields) => {
                        if (itemFields.idFieldTable === 'currencyId') {
                            let idfield = itemFields.id;
                            currencyId = field[idfield];
                        }
                    })
                }
            })
            if (!currencyId) {
                data.crud.boxes.forEach((itemBoxes) => {
                    itemBoxes.fields.forEach((itemFields) => {
                        if (itemFields.idFieldTable === 'currencyId') {
                            let idfield = itemFields.id;
                            currencyId = field[idfield];
                        }
                    })
                })
            }

            if (currencyId !== null && currencyId !== undefined) {
                const user = AuthService.getCurrentUser();
                if (currencyId.id === user.data.currencyId) {
                    data.crud.boxes.forEach((itemBoxes) => {
                        if (itemBoxes.order === orderBox) {
                            itemBoxes.fields.forEach((itemFields) => {
                                if (itemFields.idFieldTable === 'fxRate') {
                                    let idfield = itemFields.id;
                                    setField(prevState => ({
                                        ...prevState,
                                        [idfield]: 1,
                                    }), []);
                                }
                            })
                        }
                    })
                } else {

                    let date = fecha;

                    informationService.searchForeignCurrency(instance, date, currencyId.id).then((response) => {
                        let fxRate = response.data;
                        let existe = false;
                        data.crud.boxes.forEach((itemBoxes) => {
                            if (orderBox === itemBoxes.order) {
                                itemBoxes.fields.forEach((itemFields) => {
                                    if (itemFields.idFieldTable === 'fxRate') {
                                        let idfield = itemFields.id;
                                        setField(prevState => ({
                                            ...prevState,
                                            [idfield]: fxRate
                                        }), []);
                                        existe = true;
                                    }
                                })
                            }
                        })
                        if (!existe) {
                            data.crud.boxes.forEach((itemBoxes) => {
                                itemBoxes.fields.forEach((itemFields) => {
                                    if (itemFields.idFieldTable === 'fxRate') {
                                        let idfield = itemFields.id;
                                        setField(prevState => ({
                                            ...prevState,
                                            [idfield]: fxRate
                                        }), []);
                                    }
                                })
                            })
                        }
                    })
                }
            }

            //PAYMENT TERM ID
            let paymentTermId;
            data.crud.boxes.forEach((itemBoxes) => {
                if (orderBox === itemBoxes.order) {
                    itemBoxes.fields.forEach((itemFields) => {
                        if (itemFields.idFieldTable === 'paymentTermId') {
                            let idfield = itemFields.id;
                            paymentTermId = field[idfield];
                        }
                    })
                }
            })
            if (!paymentTermId) {
                data.crud.boxes.forEach((itemBoxes) => {
                    itemBoxes.fields.forEach((itemFields) => {
                        if (itemFields.idFieldTable === 'paymentTermId') {
                            let idfield = itemFields.id;
                            paymentTermId = field[idfield];
                        }
                    })
                })
            }

            if (paymentTermId !== null && paymentTermId !== undefined) {
                for (const paymentsTerms of paymentTerm) {
                    if (paymentsTerms.id === paymentTermId.id) {
                        if (paymentsTerms.isBusiness === '0') {
                            let nuevaFecha;
                            if (fecha) {
                                const dateStr = fecha;
                                const [year, month, day] = dateStr.split('-');
                                const localDate = new Date(year, month - 1, day);
                                switch (paymentsTerms.intervalCodeCode) {
                                    case "DAY":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "WEEK":
                                        nuevaFecha = addWeeks(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MONTH":
                                        nuevaFecha = addMonths(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "QUARTER":
                                        nuevaFecha = addMonths(localDate, Number(paymentsTerms.dueUnit) * 3);
                                        break;
                                    case "YEAR":
                                        nuevaFecha = addYears(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MINUTE":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "SECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MICROSECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "SECOND_MICROSECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit) + Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "MINUTE_MICROSECOND":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "MINUTE_SECOND":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR_MICROSECOND":
                                        nuevaFecha = addHours(fecha, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "HOUR_SECOND":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR_MINUTE":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMinutes(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_MICROSECOND":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "DAY_SECOND":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_MINUTE":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMinutes(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_HOUR":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addHours(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "YEAR_MONTH":
                                        nuevaFecha = addYears(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMonths(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    default:
                                        console.log("Código de unidad de medida no válido.");
                                        return;
                                }
                                let existeBox = false;
                                data.crud.boxes.forEach((itemBoxes) => {
                                    if (itemBoxes.order === orderBox) {
                                        itemBoxes.fields.forEach((itemFields) => {
                                            if (itemFields.idFieldTable === 'dueDate') {
                                                let idfield = itemFields.id;
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                }), []);
                                                existeBox = true;
                                            }
                                        })
                                    }
                                })
                                if (!existeBox) {
                                    data.crud.boxes.forEach((itemBoxes) => {
                                        itemBoxes.fields.forEach((itemFields) => {
                                            if (itemFields.idFieldTable === 'dueDate') {
                                                let idfield = itemFields.id;
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                }), []);
                                            }
                                        })
                                    })
                                }
                            }
                        }
                        if (paymentsTerms.isBusiness === '1') {
                            if (fecha !== undefined && fecha !== null) {
                                informationService.searchView(`${instance}.calendarNonBusiness`).then((response) => {

                                    const feriados = response.data.map(item => new Date(item.date));
                                    let nuevaFecha = new Date(`${fecha}T00:00:00`);
                                    let daysAdded = 0;

                                    while (daysAdded < Number(paymentsTerms.dueUnit)) {
                                        nuevaFecha = addDays(nuevaFecha, 1);
                                        const dayOfWeek = nuevaFecha.getDay();

                                        if (dayOfWeek !== 6 && dayOfWeek !== 0 && !feriados.includes(format(nuevaFecha, "yyyy-MM-dd"))) {
                                            daysAdded++;
                                        }
                                    }

                                    let existeBox = false;
                                    data.crud.boxes.forEach((itemBoxes) => {
                                        if (itemBoxes.order === orderBox) {
                                            itemBoxes.fields.forEach((itemFields) => {
                                                if (itemFields.idFieldTable === 'dueDate') {
                                                    let idfield = itemFields.id;
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                    }), []);
                                                    existeBox = true;
                                                }
                                            })
                                        }
                                    })
                                    if (!existeBox) {
                                        data.crud.boxes.forEach((itemBoxes) => {
                                            itemBoxes.fields.forEach((itemFields) => {
                                                if (itemFields.idFieldTable === 'dueDate') {
                                                    let idfield = itemFields.id;
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                    }), []);
                                                }
                                            })
                                        })
                                    }
                                });
                            }
                        }
                    }
                }
            }
        }

        //DAYS TO DUE
        if (item.idFieldTable === 'daysToDue' && !nameGroup) {
            if (changeValue) {
                let fecha;
                data.crud.boxes.forEach((itemBoxes) => {
                    if (orderBox === itemBoxes.order) {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'date') {
                                let idfield = itemFields.id;
                                fecha = field[idfield];
                            }
                        })
                    }
                })
                if (!fecha) {
                    data.crud.boxes.forEach((itemBoxes) => {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'date') {
                                let idfield = itemFields.id;
                                fecha = field[idfield];
                            }
                        })
                    })
                }
                let nuevaFecha;
                if (fecha) {
                    const dateStr = fecha;
                    const [year, month, day] = dateStr.split('-');

                    const localDate = new Date(year, month - 1, day);
                    nuevaFecha = addDays(localDate, Number(changeValue));
                }
                data.crud.boxes.forEach((itemBoxes) => {
                    if (itemBoxes.order === orderBox) {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'dueDate') {
                                let idfield = itemFields.id;
                                setField(prevState => ({
                                    ...prevState,
                                    [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                }), []);
                            }
                        })
                    }
                })
            }
        }
        //PAYMENT TERM ID
        if (item.idFieldTable === 'paymentTermId' && !nameGroup) {
            if (changeValue) {

                for (const paymentsTerms of paymentTerm) {
                    if (paymentsTerms.id === changeValue.id) {
                        if (paymentsTerms.isBusiness === '0') {
                            let fecha;

                            data.crud.boxes.forEach((itemBoxes) => {
                                if (orderBox === itemBoxes.order) {
                                    itemBoxes.fields.forEach((itemFields) => {
                                        if (itemFields.idFieldTable === 'date') {
                                            let idfield = itemFields.id;
                                            fecha = field[idfield];
                                        }
                                    })
                                }
                            })
                            if (!fecha) {
                                data.crud.boxes.forEach((itemBoxes) => {
                                    itemBoxes.fields.forEach((itemFields) => {
                                        if (itemFields.idFieldTable === 'date') {
                                            let idfield = itemFields.id;
                                            fecha = field[idfield];
                                        }
                                    })
                                })
                            }

                            let nuevaFecha;
                            const dateStr = fecha;
                            const [year, month, day] = dateStr.split('-');
                            const localDate = new Date(year, month - 1, day);
                            if (fecha) {
                                switch (paymentsTerms.intervalCodeCode) {
                                    case "DAY":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "WEEK":
                                        nuevaFecha = addWeeks(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MONTH":
                                        nuevaFecha = addMonths(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "QUARTER":
                                        nuevaFecha = addMonths(localDate, Number(paymentsTerms.dueUnit) * 3);
                                        break;
                                    case "YEAR":
                                        nuevaFecha = addYears(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MINUTE":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "SECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MICROSECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "SECOND_MICROSECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit) + Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "MINUTE_MICROSECOND":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "MINUTE_SECOND":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR_MICROSECOND":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "HOUR_SECOND":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR_MINUTE":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMinutes(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_MICROSECOND":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "DAY_SECOND":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_MINUTE":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMinutes(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_HOUR":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addHours(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "YEAR_MONTH":
                                        nuevaFecha = addYears(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMonths(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    default:
                                        console.log("Código de unidad de medida no válido.");
                                        return;
                                }
                                data.crud.boxes.forEach((itemBoxes) => {
                                    if (itemBoxes.order === orderBox) {
                                        itemBoxes.fields.forEach((itemFields) => {
                                            if (itemFields.idFieldTable === 'dueDate') {
                                                let idfield = itemFields.id;

                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                }), []);
                                            }
                                        })
                                    }
                                })
                            }
                        }
                        if (paymentsTerms.isBusiness === '1') {
                            let fecha;
                            data.crud.boxes.forEach((itemBoxes) => {
                                if (orderBox === itemBoxes.order) {
                                    itemBoxes.fields.forEach((itemFields) => {
                                        if (itemFields.idFieldTable === 'date') {
                                            let idfield = itemFields.id;
                                            fecha = field[idfield];
                                        }
                                    })
                                }
                            })
                            if (!fecha) {
                                data.crud.boxes.forEach((itemBoxes) => {
                                    itemBoxes.fields.forEach((itemFields) => {
                                        if (itemFields.idFieldTable === 'date') {
                                            let idfield = itemFields.id;
                                            fecha = field[idfield];
                                        }
                                    })
                                })
                            }
                            if (fecha !== undefined && fecha !== null) {
                                informationService.searchView(`${instance}.calendarNonBusiness`).then((response) => {
                                    const feriados = response.data.map(item => new Date(item.date));
                                    let nuevaFecha = new Date(`${fecha}T00:00:00`);
                                    let daysAdded = 0;

                                    while (daysAdded < Number(paymentsTerms.dueUnit)) {
                                        nuevaFecha = addDays(nuevaFecha, 1);
                                        const dayOfWeek = nuevaFecha.getDay();

                                        if (dayOfWeek !== 6 && dayOfWeek !== 0 && !feriados.includes(format(nuevaFecha, "yyyy-MM-dd"))) {
                                            daysAdded++;
                                        }
                                    }
                                    data.crud.boxes.forEach((itemBoxes) => {
                                        if (itemBoxes.order === orderBox) {
                                            itemBoxes.fields.forEach((itemFields) => {
                                                if (itemFields.idFieldTable === 'dueDate') {
                                                    let idfield = itemFields.id;

                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                    }), []);
                                                }
                                            });
                                        }
                                    });
                                });
                            }
                        }
                    }
                }
            }
        }
        //functions entity tin/pin
        if (item.idFieldTable === 'argTin' || item.idFieldTable === 'argPin') {

            data.crud.boxes.forEach((itemBoxes) => {
                itemBoxes.fields.forEach((itemFields) => {
                    if (item.idFieldTable === 'argTin') {
                        if (itemFields.idFieldTable === 'tin') {
                            let idfield = itemFields.id;
                            if (!field[idfield]) {
                                setField(prevState => ({
                                    ...prevState,
                                    [idfield]: changeValue
                                }));
                            }
                        }
                    } else {
                        if (itemFields.idFieldTable === 'pin') {

                            let idfield = itemFields.id;
                            if (!field[idfield]) {
                                setField(prevState => ({
                                    ...prevState,
                                    [idfield]: changeValue
                                }));
                            }
                        }
                    }
                })
            })
        }

        //entity argRpcRegNumber
        let idArgRpcRegNumber;
        let argRpcRegNumber;
        let argRpcRegBook;
        let argRpcRegFolio;
        let argRpcRegVolume;
        let argRegNumber;

        data.crud.boxes.forEach((itemBoxes) => {
            itemBoxes.fields.forEach((itemFields) => {
                if (itemFields.idFieldTable === 'argCvRegTypeId') {
                    idArgRpcRegNumber = itemFields.id;
                }
                if (itemFields.idFieldTable === 'argRpcRegNumber') {
                    argRpcRegNumber = itemFields.id;
                }
                if (itemFields.idFieldTable === 'argRpcRegBook') {
                    argRpcRegBook = itemFields.id;
                }
                if (itemFields.idFieldTable === 'argRpcRegFolio') {
                    argRpcRegFolio = itemFields.id;
                }
                if (itemFields.idFieldTable === 'argRpcRegVolume') {
                    argRpcRegVolume = itemFields.id;
                }
                if (itemFields.idFieldTable === 'argRegNumber') {
                    argRegNumber = itemFields.id;
                }
            })
        })

        if (id === argRpcRegNumber || id === argRpcRegBook || id === argRpcRegFolio || id === argRpcRegVolume) {
            if (Number(field[idArgRpcRegNumber].id) === 1) {
                if (item.idFieldTable === 'argRpcRegNumber')
                    argRpcRegNumber = changeValue;
                else
                    argRpcRegNumber = field[argRpcRegNumber];
                if (item.idFieldTable === 'argRpcRegBook')
                    argRpcRegBook = changeValue;
                else
                    argRpcRegBook = field[argRpcRegBook];
                if (item.idFieldTable === 'argRpcRegFolio')
                    argRpcRegFolio = changeValue;
                else
                    argRpcRegFolio = field[argRpcRegFolio];
                if (item.idFieldTable === 'argRpcRegVolume')
                    argRpcRegVolume = changeValue;
                else
                    argRpcRegVolume = field[argRpcRegVolume];

                let valueArgRegNumber = `${argRpcRegNumber}${argRpcRegBook}${argRpcRegFolio}${argRpcRegVolume}`;
                setField(prevState => ({
                    ...prevState,
                    [argRegNumber]: valueArgRegNumber
                }));
            }
        }

        //addressBook isDefault
        if (nameGroup) {

            if (item.idFieldTable === 'addressTypeId') {
                let existe = false;
                let idSwitch;
                for (let y = 0; y < group[nameGroup].length; y++) {
                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                        if (y === index) {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'isDefault') {
                                idSwitch = group[nameGroup][y].fields[i].id;
                            }
                        }
                    }
                }

                for (let y = 0; y < group[nameGroup].length; y++) {

                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                        if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {
                            if (y !== index) {
                                if (field[group[nameGroup][y].fields[i].id]) {
                                    if (Number(changeValue.id) === Number(field[group[nameGroup][y].fields[i].id].id)) {
                                        existe = true;
                                    }
                                }
                            }
                        }
                    }
                }
                if (existe === false) {
                    setField(prevState => ({
                        ...prevState,
                        [idSwitch]: true
                    }), []);
                } else {
                    setField(prevState => ({
                        ...prevState,
                        [idSwitch]: false
                    }), []);
                }
            }

            //PAYMENT TERM ID
            if (item.idFieldTable === 'paymentTermId' && mode !== 'r') {
                if (changeValue) {

                    for (const paymentsTerms of paymentTerm) {
                        if (paymentsTerms.id === changeValue.id) {
                            if (paymentsTerms.isBusiness === '0') {
                                let fecha;

                                for (let y = 0; y < group[nameGroup].length; y++) {
                                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                        if (y === index) {
                                            if (group[nameGroup][y].fields[i].idFieldTable === 'date') {
                                                fecha = group[nameGroup][y].fields[i].id;
                                            }
                                        }
                                    }
                                }

                                if (!fecha) {
                                    data.crud.boxes.forEach((itemBoxes) => {
                                        itemBoxes.fields.forEach((itemFields) => {
                                            if (itemFields.idFieldTable === 'date') {
                                                let idfield = itemFields.id;
                                                fecha = field[idfield];
                                            }
                                        })
                                    })
                                }
                                let nuevaFecha;
                                const dateStr = fecha;
                                const [year, month, day] = dateStr.split('-');
                                const localDate = new Date(year, month - 1, day);
                                switch (paymentsTerms.intervalCodeCode) {
                                    case "DAY":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "WEEK":
                                        nuevaFecha = addWeeks(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MONTH":
                                        nuevaFecha = addMonths(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "QUARTER":
                                        nuevaFecha = addMonths(localDate, Number(paymentsTerms.dueUnit) * 3);
                                        break;
                                    case "YEAR":
                                        nuevaFecha = addYears(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MINUTE":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "SECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "MICROSECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "SECOND_MICROSECOND":
                                        nuevaFecha = addSeconds(localDate, Number(paymentsTerms.dueUnit) + Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "MINUTE_MICROSECOND":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "MINUTE_SECOND":
                                        nuevaFecha = addMinutes(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR_MICROSECOND":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "HOUR_SECOND":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "HOUR_MINUTE":
                                        nuevaFecha = addHours(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMinutes(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_MICROSECOND":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit)).setSeconds(Number(paymentsTerms.dueUnit) / 1000000);
                                        break;
                                    case "DAY_SECOND":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addSeconds(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_MINUTE":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMinutes(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "DAY_HOUR":
                                        nuevaFecha = addDays(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addHours(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    case "YEAR_MONTH":
                                        nuevaFecha = addYears(localDate, Number(paymentsTerms.dueUnit));
                                        nuevaFecha = addMonths(nuevaFecha, Number(paymentsTerms.dueUnit));
                                        break;
                                    default:
                                        console.log("Código de unidad de medida no válido.");
                                        return;
                                }

                                for (let y = 0; y < group[nameGroup].length; y++) {
                                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                        if (y === index) {
                                            if (group[nameGroup][y].fields[i].idFieldTable === 'dueDate') {
                                                let idfield = group[nameGroup][y].fields[i].id;
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                }), []);
                                            }
                                        }
                                    }
                                }

                            }
                            if (paymentsTerms.isBusiness === '1') {
                                let fecha;

                                for (let y = 0; y < group[nameGroup].length; y++) {
                                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                        if (y === index) {
                                            if (group[nameGroup][y].fields[i].idFieldTable === 'date') {
                                                fecha = group[nameGroup][y].fields[i].id;
                                            }
                                        }
                                    }
                                }

                                if (!fecha) {
                                    data.crud.boxes.forEach((itemBoxes) => {
                                        itemBoxes.fields.forEach((itemFields) => {
                                            if (itemFields.idFieldTable === 'date') {
                                                let idfield = itemFields.id;
                                                fecha = field[idfield];
                                            }
                                        })
                                    })
                                }

                                if (fecha !== undefined && fecha !== null) {
                                    informationService.searchView(`${instance}.calendarNonBusiness`).then((response) => {

                                        const feriados = response.data.map(item => new Date(item.date));
                                        let nuevaFecha = new Date(`${fecha}T00:00:00`);
                                        let daysAdded = 0;

                                        while (daysAdded < Number(paymentsTerms.dueUnit)) {
                                            nuevaFecha = addDays(nuevaFecha, 1);
                                            const dayOfWeek = nuevaFecha.getDay();

                                            if (dayOfWeek !== 6 && dayOfWeek !== 0 && !feriados.includes(format(nuevaFecha, "yyyy-MM-dd"))) {
                                                daysAdded++;
                                            }
                                        }

                                        for (let y = 0; y < group[nameGroup].length; y++) {
                                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                                if (y === index) {
                                                    if (group[nameGroup][y].fields[i].idFieldTable === 'dueDate') {
                                                        let idfield = group[nameGroup][y].fields[i].id;
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idfield]: format(nuevaFecha, "yyyy-MM-dd"),
                                                        }), []);
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            }

            if (item.idFieldTable === 'isDefault') {

                if (changeValue === true) {
                    let idAddressType;
                    let existe = false;
                    let indexUpdate;
                    for (let y = 0; y < group[nameGroup].length; y++) {
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                            if (y === index) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {
                                    let idAddressTypeId = group[nameGroup][y].fields[i].id;
                                    if (field[idAddressTypeId])
                                        idAddressType = Number(field[idAddressTypeId].id)
                                }
                            }
                        }
                    }
                    for (let y = 0; y < group[nameGroup].length; y++) {
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {
                                if (y !== index) {
                                    if (field[group[nameGroup][y].fields[i].id]) {
                                        if (idAddressType === Number(field[group[nameGroup][y].fields[i].id].id)) {
                                            existe = true;
                                            indexUpdate = y;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (existe === true) {
                        for (let y = 0; y < group[nameGroup].length; y++) {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'isDefault') {
                                    if (y === indexUpdate) {
                                        let idSwitch = group[nameGroup][y].fields[i].id;
                                        setField(prevState => ({
                                            ...prevState,
                                            [idSwitch]: false
                                        }), []);
                                    }
                                }
                            }
                        }
                    }

                } else {
                    if (group[nameGroup].length === 1) {
                        setField(prevState => ({
                            ...prevState,
                            [id]: true
                        }), []);
                    } else {
                        let idEntityType = null;
                        let existe = false;
                        let indexUpdate;
                        for (let y = 0; y < group[nameGroup].length; y++) {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {
                                    if (y === index) {
                                        if (field[group[nameGroup][y].fields[i].id])
                                            idEntityType = Number(field[group[nameGroup][y].fields[i].id].id);
                                    }
                                }
                            }
                        }

                        for (let y = 0; y < group[nameGroup].length; y++) {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'addressTypeId') {
                                    if (y !== index) {
                                        if (field[group[nameGroup][y].fields[i].id]) {
                                            if (idEntityType === Number(field[group[nameGroup][y].fields[i].id].id)) {
                                                existe = true;
                                                indexUpdate = y;
                                            }
                                        }

                                    }
                                }
                            }
                        }

                        if (existe === false) {
                            setField(prevState => ({
                                ...prevState,
                                [id]: true
                            }), []);
                        } else {
                            for (let y = 0; y < group[nameGroup].length; y++) {
                                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                    if (group[nameGroup][y].fields[i].idFieldTable === 'isDefault') {
                                        if (y === indexUpdate) {
                                            let idSwitch = group[nameGroup][y].fields[i].id;
                                            setField(prevState => ({
                                                ...prevState,
                                                [idSwitch]: true
                                            }), []);
                                        }
                                    }
                                }
                            }
                        }
                    }

                }
            }

            //addressBook name
            if (item.idFieldTable === 'street' || item.idFieldTable === 'number' || item.idFieldTable === 'floor' || item.idFieldTable === 'department') {
                let nameId;
                let nameAltId;
                let street;
                let streetId;
                let number;
                let numberId;
                let floor;
                let floorId;
                let department;
                let departmentId;
                for (let y = 0; y < group[nameGroup].length; y++) {
                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                        if (y === index) {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'name') {
                                nameId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'nameAlt') {
                                nameAltId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'street') {
                                streetId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'number') {
                                numberId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'floor') {
                                floorId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'department') {
                                departmentId = group[nameGroup][y].fields[i].id;
                            }
                        }
                    }
                }

                if (item.idFieldTable === 'street')
                    street = changeValue;
                else
                    street = field[streetId];

                if (item.idFieldTable === 'number')
                    number = changeValue;
                else
                    number = field[numberId];

                if (item.idFieldTable === 'floor')
                    floor = changeValue;
                else
                    floor = field[floorId];

                if (item.idFieldTable === 'department')
                    department = changeValue;
                else
                    department = field[departmentId];

                setField(prevState => ({
                    ...prevState,
                    [nameId]: `${street} ${number}`,
                    [nameAltId]: `Piso: ${floor} Dpto.: ${department}`
                }), []);
            }

            //addressBook zip
            if (item.idFieldTable === 'zipId') {
                let countryId;
                let zipTxtId;
                let cityId;
                let stateId;
                let stateTxtId;
                for (let y = 0; y < group[nameGroup].length; y++) {
                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                        if (y === index) {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'countryId') {
                                countryId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'zipTxt') {
                                zipTxtId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'city') {
                                cityId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'stateTxt') {
                                stateTxtId = group[nameGroup][y].fields[i].id;
                            }
                            if (group[nameGroup][y].fields[i].idFieldTable === 'stateId') {
                                stateId = group[nameGroup][y].fields[i].id;
                            }
                        }
                    }
                }
                if (field[countryId]) {
                    if (Number(field[countryId].id) === 10) {
                        info.forEach(item => {
                            if (Number(item.id) === Number(changeValue.id) && item.source === 'zip') {
                                let stateTxt;
                                let stateObj = {};
                                info.forEach(item1 => {

                                    if (Number(item.stateId) === Number(item1.id) && item1.source === 'state') {
                                        stateTxt = item1.name;
                                        stateObj = {
                                            id: item1.id,
                                            label: item1.nameAlt !== undefined ? `${item1.name} ${item1.nameAlt}` : `${item1.name}`,
                                        }
                                    }
                                })
                                setField(prevState => ({
                                    ...prevState,
                                    [zipTxtId]: item.name,
                                    [cityId]: item.nameAlt,
                                    [stateId]: stateObj,
                                    [stateTxtId]: stateTxt,
                                }), []);
                            }
                        })
                    }
                }


            }
            //functions entity tin/pin
            if (item.idFieldTable === 'argTin' || item.idFieldTable === 'argPin') {
                for (let y = 0; y < group[nameGroup].length; y++) {
                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                        if (item.idFieldTable === 'argTin') {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'tin') {
                                let idg = group[nameGroup][y].fields[i].id;
                                if (!field[idg]) {
                                    setField(prevState => ({
                                        ...prevState,
                                        [idg]: changeValue
                                    }), []);
                                }
                            }
                        }
                        if (item.idFieldTable === 'argPin') {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'pin') {
                                let idg = group[nameGroup][y].fields[i].id;
                                if (!field[idg]) {
                                    setField(prevState => ({
                                        ...prevState,
                                        [idg]: changeValue
                                    }), []);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

const globalFunctions = {
    entityTinPin,
    entityArgRpcRegNumber,
    addressBook,
    entityTinPinGroup,
    calcularPerfilInversor,
    requestCode,
    globalFunctionsDocs
}

export default globalFunctions;